module.exports = __webpack_public_path__ + "img/jumelles.7c87c7df.svg";